// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64ffe87b","460":"a1177056","597":"79574e34","681":"f1bb5788","880":"845a2419"}[chunkId] + ".chunk.js";
};